module.exports = __webpack_public_path__ + "static/img/RU@3x.b6f5c380.jpg";